import { config } from "../../config";
import type { LogsInitConfiguration } from "@datadog/browser-logs";
import type { RumInitConfiguration } from "@datadog/browser-rum";

export const rumConfig: RumInitConfiguration = {
  applicationId: String(config.datadog.applicationId),
  clientToken: String(config.datadog.clientToken),
  service: "client-applicant",
  sessionSampleRate: 100,
  env: config.environment,
  sessionReplaySampleRate: 100,
  site: "datadoghq.com",
  allowedTracingUrls: [
    "https://api.production.boompay.app",
    "https://api.staging.boompay.app",
    "https://api.sandbox.boompay.app"
  ],
  version: config.buildId,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: "allow"
};

export const logsConfig: LogsInitConfiguration = {
  clientToken: String(config.datadog.clientToken),
  service: "client-applicant",
  env: config.environment,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: "all",
  version: config.buildId,
  forwardReports: "all",
  sessionSampleRate: 100,
  telemetrySampleRate: 100
};
